import { Grid } from 'antd';
import { uniq } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
    FilterContainer,
    FilterGroupContainer,
} from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/ui';
import { useCarListingState } from '../CarListingStateProvider';
import CarConditionFilter from './CarConditionFilter';
import CarModelFilter from './CarModelFilter';
import MonthlyPaymentFilter from './MonthlyPaymentFilter';

export const Container = styled.div`
    & h5.ant-typography {
        font-size: 20px;
    }

    & > div:not(:last-child) {
        margin-bottom: 50px;
    }
`;

const CarFilterContent = () => {
    const { t } = useTranslation(['core']);
    const screens = Grid.useBreakpoint();
    const {
        meta: { endpoint },
    } = useCarListingState();

    const conditions = useMemo(
        () => uniq(endpoint.finderApplicationModules.flatMap(({ finderVehicleConditions }) => finderVehicleConditions)),
        [endpoint.finderApplicationModules]
    );

    return (
        <FilterContainer
            $leftBordered={screens.md && t('core:orientation') === 'ltr'}
            $rightBordered={screens.md && t('core:orientation') === 'rtl'}
        >
            <Container>
                {conditions.length > 1 && (
                    <FilterGroupContainer>
                        <CarConditionFilter conditions={conditions} />
                    </FilterGroupContainer>
                )}
                <FilterGroupContainer>
                    <CarModelFilter />
                </FilterGroupContainer>
                <FilterGroupContainer>
                    <MonthlyPaymentFilter />
                </FilterGroupContainer>
            </Container>
        </FilterContainer>
    );
};

export default CarFilterContent;
